module.exports = __webpack_public_path__ + "static/media/grouped_attachment.a63053d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/grouped_attachment.png
// module id = 1667
// module chunks = 17